<template lang="pug">
  div.registration-protocol
    div.title
      div.name 用户协议
      button.fa.fa-close(@click.prevent="$emit('close')")
    div.text
      p 北京宏博知微科技有限公司（以下简称“知微”）在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户协议》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
      p 本协议约定知微与用户之间关于“企业危机案例库”平台服务（以下简称“服务”）的权利义务。“用户”是指注册、登录、使用本服务的个人。本协议可由知微随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本网站查阅最新版协议条款。在知微修改协议条款后，如果用户不接受修改后的条款，请立即停止使用知微提供的服务，用户继续使用知微提供的服务将被视为接受修改后的协议。
      h3 一、注册信息与隐私保护
      ul
        li 1.服务帐号（即服务用户ID）的所有权归知微，用户按注册页面引导填写信息，阅读并同意本协议且完成全部注册程序后，即可获得帐号并成为服务用户。用户应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实或更新不及时而引发的相关问题，知微不负任何责任，用户应当通过真实身份信息认证注册帐号，且用户提交的帐号名称、头像等注册信息中不得出现违法和不良信息，经知微审核，如存在上述情况，将不予注册；同时，在注册后，知微有权对用户的注册资料进行审查，对存在任何问题或怀疑的注册资料，知微有权发出通知询问用户并要求用户做出解释、改正，如发现用户以虚假信息骗取帐号名称注册，或其帐号头像、简介等注册信息存在违法和不良信息的，知微有权不经通知单方采取限期改正、暂停使用、注销登记、收回等措施。
        li 2.服务帐号包括帐户名称和密码，您可使用设置的帐户名称（包括手机号、微信账号）和密码登录平台；在帐号使用过程中，为了保障您的帐号安全基于不同的终端以及您的使用习惯，我们可能采取不同的验证措施识别您的身份。例如您的帐户在新设备首次登录，我们可能通过密码加校验码的方式识别您的身份，验证方式包括但不限于短信验证码、服务使用信息验证。
        li 3.用户不应将其帐号、密码转让、出售或出借予他人使用，若用户授权他人使用帐户，应对被授权人在该帐户下发生所有行为负全部责任。由于帐号关联用户使用信息，仅当依法律法规、司法裁定或经知微同意，并符合知微规定的用户帐号转让流程的情况下，方可进行帐号的转让。
        li 4.因您个人原因导致的帐号信息遗失，如需找回服务帐号信息，请按照服务帐号找回要求提供相应的信息，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过服务安全验证，知微有权拒绝提供帐号找回服务；若帐号的唯一凭证不再有效，知微有权拒绝支持帐号找回。例如手机号二次出售，知微可拒绝支持帮助找回原手机号绑定的帐号。
        li 5.当您使用知微产品进行登录、支付等操作的时候，服务器会自动收取并记录一些必要的信息，如IP地址、服务访问异常信息、以及部分设备信息等，以保障您在使用服务时账号登录和支付过程的安全，进而保护您的上网安全。您使用知微的服务，即表示您同意知微可以按照相关的隐私权政策处理您的个人信息。知微可能会向您提供您所要求的服务或者向您展示您可能感兴趣的内容。知微会确保数据安全并且禁止用于任何其他用途。同时，知微不会向任何无关第三方提供或分享信息。
        li
          | 6.在如下情况下，知微可能会披露您的信息:
          ol
            li  （1）事先获得您的授权；
            li  （2）您使用共享功能；
            li  （3）根据法律、法规、法律程序的要求或政府主管部门的强制性要求；
            li  （4）为维护知微的合法权益，例如查找、预防、处理欺诈或安全方面的问题；
            li  （5）符合相关服务条款或使用协议的规定。
        li 7.为更好地向用户提供服务，您同意知微通过短信等形式向您发送相关商业性服务信息。
      h3 二、使用规则
      ul
        li
          | 1.用户在使用服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为:
          ol
            li  （1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的；
            li  （2）未经允许，对计算机信息网络功能进行删除、修改或者增加的；
            li  （3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；
            li  （4）故意制作、传播计算机病毒等破坏性程序的；
            li  （5）其他危害计算机信息网络安全的行为。
        li 2.用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿知微与合作公司、关联公司，并使之免受损害。对此，知微有权视用户的行为性质，采取包括但不限于暂停使用许可、终止服务、限制使用、回收服务帐号、追究法律责任等措施。对恶意注册服务帐号或利用服务帐号进行违法活动、捣乱、骚扰、欺骗、其他用户以及其他违反本协议的行为，知微有权回收其帐号。同时，知微会视司法部门的要求，协助调查。
        li 3.用户不得对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。
        li 4.用户不得违反《银行卡业务管理办法》使用银行卡，或利用信用卡套取现金（以下简称套现）。
        li 5.用户须对自己在使用服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在知微首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予知微等额的赔偿。
      h3 三、平台服务内容
      ul
        li 1.除非本服务协议另有其它明示规定，知微所推出的新产品、新功能、新服务，均受到本服务协议之规范。
        li 2.为使用本服务，您必须能够自行经有法律资格对您提供互联网接入服务的第三方，进入国际互联网，并应自行支付相关服务费用。此外，您必须自行配备及负责与国际联网连线所需之一切必要装备，包括计算机、数据机或其它存取装置。
        li 3.鉴于网络服务的特殊性，用户同意知微有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。知微不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。
        li
          | 4.免责声明：因以下情况造成网络服务在合理时间内的中断，知微无需为此承担任何责任；
          ol
            li  （1）知微需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，知微保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。
            li  （2）因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；
            li  （3）用户的电脑软硬件和通信线路、供电线路出现故障的；
            li  （4）因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府行为等原因。
        li 5.尽管有前款约定，知微将采取合理行动积极促使服务恢复正常。
        li 6.本服务或第三人可提供与其它国际互联网上之网站或资源之链接。由于知微无法控制这些网站及资源，您了解并同意，此类网站或资源是否可供利用，知微不予负责，存在或源于此类网站或资源之任何内容、广告、产品或其它资料，知微亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，知微不承担任何责任。
        li 7.用户明确同意其使用知微网络服务所存在的风险将完全由其自己承担。用户理解并接受下载或通过知微取得的任何信息资料取决于用户自己，并由其承担系统受损、资料丢失以及其它任何风险。
        li 8. 知微有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，知微对用户和任何第三人均无需承担任何责任。您同意知微得基于其自行之考虑，因任何理由，包含但不限于知微认为您已经违反本服务协议的文字及精神，终止您的密码、帐号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本服务协议任何规定提供之本服务，无需进行事先通知即可中断或终止，您承认并同意，知微可立即关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的帐号及相关信息和文件被关闭或删除，知微对您或任何第三人均不承担任何责任。
      h3 四、知识产权
      ul
        li 1. 服务网站所有的产品、技术与所有程序等相关知识产权均属于知微，在此并未授权。未经知微许可，任何人不得擅自（包括但不限于：复制、传播、展示、镜像、上载、下载等）使用。否则，知微将依法追究法律责任。
        li 2. 知微授予用户普通（即不可转移、转让和非专属）的许可使用权，使用户可以通过单机计算机使用服务的目标代码，但用户不得且不得允许任何第三方复制、修改、创作衍生作品、进行还原工程、反向组译，或以其它方式破译或试图破译源代码，或出售、转让目标代码或对目标代码进行再授权，或以其它方式移转目标代码之任何权利。用户同意不以任何方式修改目标代码，或使用修改后的目标代码。
      h3 五、其他
      ul
        li 1.本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。
        li 2.如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向知微所在地法院提起诉讼。
        li 3.知微未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。
        li 4.如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
    div.submit
      button(@click.prevent="makeDicision(true)") 同意
      button(@click.prevent="makeDicision(false)") 不同意
</template>
<script>
export default {
  name: 'RegistrationProtocol',
  props: {
    agreeProtocol: {
      type: Function,
      required: true
    }
  },
  methods: {
    makeDicision (status) {
      this.agreeProtocol(status)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.registration-protocol {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  width: 655px;
  height: 666px;
  padding: 25px;
  background-color: rgba(0, 0, 0, 0.7);
  border: solid 1px rgba(255, 255, 255, 0.3);
  color: #fff;
  overflow-y: auto;
}

.text {

  p {
    margin-bottom: 1em;
    text-indent: 2em;
  }

  h3 {
    margin: 0.75em 0;
  }

  ul {
    list-style: none;
    line-height: 1.8;

    li {}
  }

  ol {
    list-style: none;
    line-height: 1.8;

    li {
      text-indent: 1em;
    }
  }
}

.title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-bottom: 15px;

  .name {
    text-align: center;
    flex: 1;
    font-size: 18px;
  }

  button {
    background: transparent;
    border: none;
    font-size: 18px;
  }
}

p {
  font-size: 12px;
  margin-bottom: 15px;
}

.submit {
  text-align: center;

  button {
    width: 148px;
    height: 40px;
    background-color: rgba(91, 192, 222, 0.4);
    border: solid 1px #46b8da;
    margin: 0 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/RegistrationProtocol.vue